/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./LandingPage.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useAssessment } from "../self-assesment/AssessmentContext.js";
import { AnalyticsService, BrowserBlockScreen, LandingPageModal } from "../self-assesment/SelfAssesment.jsx";
import { Header } from "./Header.jsx";
import { Footer } from "./Footer.jsx";
import { StartMyra } from "./StartMyra.jsx";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

export const AboutUs = () => {
  ScrollToTop();
  const [showMemberBlockScreen, setShowMemberBlockScreen] = useState(false);
  const { resetAssessmentData, assessmentData, updateAssessmentData, isMyRAIsActive, setIsMyRAIsActive } = useAssessment();
  const [isMicModalActive, setIsMicModalActive] = useState(false);
  const [micModalMsg, setMicModalMsg] = useState("To chat with Myra, please grant microphone access. Your audio is processed in real-time and never stored or recorded.");
  const [access, setAccess] = useState(true);
  const [showAgeModal, setShowAgeModal] = useState(false);
  const history = useHistory();
  const onGrant = () => {
    setIsMicModalActive(false);
    if (window._myraPermissionCallbacks?.onGrant) {
      window._myraPermissionCallbacks.onGrant();
    }
  };

  const oncancel = () => {
    window.isStartedLandingFlow = false;
    window.isUserChatWithMyra = false;
    setAccess(false);
    setIsMyRAIsActive(false);
    setMicModalMsg("Mic access is needed to chat with Myra. You can still start the Guided Self-Assessment anytime—the button is just below the video. Text chat is coming soon!");
    if (window._myraPermissionCallbacks?.onCancel) {
      window._myraPermissionCallbacks.onCancel();
    }
  };
  const LinkedInIcon = () => (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
    </svg>
  );
  const handleHomeButtonCLicked = () => {
    // Cleanup
    resetAssessmentData();
    localStorage.removeItem("assessmentData");
    localStorage.removeItem("dataAfterInfo");
    if (!window.isUserChatWithMyra) {
      console.log("Didn't Started Landing FLow Removing Conditions");
      localStorage.removeItem("userCondition");
    }

    window.screenTracker.exitScreen("landing", {
      exitReason: "started_gsa",
      completed: true,
    });

    // 2. Get the screen flow array (not nested object)
    const finalScreenFlow = window.screenTracker.getScreenFlow();

    // 3. Get timing data
    const timingData = window.timeTracker.startGSATimer();
    let landingDurationSec = null;
    if (finalScreenFlow.length > 0) {
      const landingScreen = finalScreenFlow.find((s) => s.screen === "landing");
      if (landingScreen && landingScreen.enteredAt && landingScreen.exitedAt) {
        const start = new Date(landingScreen.enteredAt);
        const end = new Date(landingScreen.exitedAt);
        landingDurationSec = Math.round((end - start) / 1000);
      }
    }

    // 4. Prepare data - send INDIVIDUAL fields
    const updatedData = {
      ...assessmentData,
      started_assessment: true,
      myraEngagedLanding: window.isUserChatWithMyra ? true : false,
      ...timingData,
      screenFlow: finalScreenFlow,
      gsaStartedAt: timingData,
      timeOnLandingSec: landingDurationSec,
      analyticsId: window.trSessionId || localStorage.getItem("trSessionId"),
      session_last_update: new Date().toISOString(),
      EngagedOnLanding: window.isStartedLandingFlow ? true : false,
    };

    // Update and track
    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));
    AnalyticsService.trackStep(updatedData);

    if (!window.trSessionId) {
      AnalyticsService.startSession();
    }

    history.replace("/red-flags");
  };

  /* ===== Leader Bio Card Component ===== */
  const LeaderCard = ({ name, title, shortBio, fullBio, linkedIn, image }) => {
    const [expanded, setExpanded] = useState(false);

    return (
      <>
        <div className="leader-card">
          {/* <div className="leader-photo">Photo</div> */}
          <img src={image} alt="avatar-pic" className="leader-photo" />
          <div className="leader-info">
            <h3>{name}</h3>
            <p className="leader-title">{title}</p>
            <div className="leader-bio">{expanded ? fullBio : shortBio}</div>
            <button className="leader-expand" onClick={() => setExpanded(!expanded)}>
              {expanded ? "See Less ▴" : "See More ▾"}
            </button>
            <div className="leader-social">
              <a href={linkedIn} target="_blank" rel="noopener noreferrer">
                <LinkedInIcon />
              </a>
            </div>
          </div>
        </div>
      </>
    );
  };

  /* ===== Leadership data ===== */
  const leaders = [
    {
      name: "Arjun Rishi",
      title: "Co-Founder & CEO",
      shortBio: "Arjun Rishi is a repeat entrepreneur focused on making recovery more human-centric. After his own struggles with muscle and joint pain, he founded Virdio Health to transform recovery with AI, AR, and motion intelligence. Previously, he scaled Vastera (NASDAQ: VAST) globally and led fitness-tech startup Khaylo.",
      fullBio: "Arjun Rishi is a seasoned entrepreneur with a strong track record in technology and innovation that drives real-world impact. He founded Virdio Health in 2019 to revolutionize muscle and joint recovery through AI, motion intelligence, behavioral science, and augmented reality. A passionate fitness enthusiast, Arjun personally experienced the challenges of staying consistent with recovery during his own lower back and knee issues. These experiences, coupled with his expertise in motion technology, inspired him to create Virdio Health, a platform designed to make recovery effective, personalized, and accessible from anywhere. Prior to Virdio Health, Arjun led Khaylo, a machine learning company leveraging smartphone sensors for exercise tracking, and founded Vastera (NASDAQ: VAST), scaling it from a three-person operation to a global organization with over 600 employees across 15 countries before taking it public.",
      linkedIn: "https://www.linkedin.com/in/arjunrishi",
      image: "/aboutimg/rishi.svg",
    },
    {
      name: "Ty Bordner",
      title: "Co-Founder & Chief Commercial Officer",
      shortBio: "Ty Bordner leads growth and revenue strategies at Virdio Health. With over 30 years of experience, he's scaled businesses like Vastera and Amber Road to IPO and strategic acquisitions.",
      fullBio: "Ty Bordner brings over three decades of experience in enterprise software, commercial strategy, and go-to-market leadership. At Virdio Health, he oversees strategic partnerships, business development, and revenue growth. Previously, he held senior leadership roles at Amber Road, where he played a critical role in enabling the company's IPO and subsequent acquisition by e2open in 2019. Prior to that he held executive roles in engineering, sales and product management helping Vastera scale the company to its IPO and eventual acquisition by JPMorgan Chase.",
      linkedIn: "https://www.linkedin.com/company/virdiohealth",
      image: "/aboutimg/bordner.svg",
    },
    {
      name: "Nicholas Sterling",
      title: "Chief R&D Officer",
      shortBio: "Nicholas Sterling leads the development of Virdio Health's AI and motion intelligence platform. With 30+ years in AI and real-time systems, his leadership ensures seamless, advanced motion tracking and adaptive recovery experiences.",
      fullBio: "Nicholas Sterling is a technology leader with over 30 years of experience in cutting-edge software innovation, specializing in real-time systems and AI-driven solutions. At Virdio Health, Nicholas leads the development of the company's proprietary motion recognition and AI coaching engine, enabling advanced guided recovery experiences without external hardware. Previously, Nicholas was Principal Software Architect at Khaylo, where he advanced exercise recognition using mobile-driven machine learning. He also held leadership roles at companies such as Coraid and Sun Microsystems.",
      linkedIn: "https://www.linkedin.com/company/virdiohealth",
      image: "/aboutimg/Sterling.svg",
    },
    {
      name: "Dr. Mehul Desai",
      title: "Chief Medical Officer",
      shortBio: "Dr. Desai is a pain medicine and physical medicine & rehabilitation expert driving clinical strategy at Virdio Health. A board-certified physician and academic leader, he ensures the platform delivers effective, evidence-based outcomes for muscle and joint recovery.",
      fullBio: "Dr. Desai is a nationally respected leader in pain medicine and musculoskeletal care, with more than 20 years of clinical experience. At Virdio Health, Dr. Desai leads the company's clinical strategy and research, ensuring the platform stays grounded in evidence-based care and delivers meaningful outcomes. Dr. Desai is board-certified in Pain Medicine and Physical Medicine & Rehabilitation.",
      linkedIn: "https://www.linkedin.com/company/virdiohealth",
      image: "/aboutimg/Desai.png",
    },
  ];

  /* ===== Advisory Board data ===== */
  const advisors = [
    {
      name: "McKenna Lupold, DPT",
      title: "Board Advisor",
      shortBio: "McKenna Lupold, DPT, is a licensed Doctor of Physical Therapy and pelvic health specialist who advises Virdio Health on clinical workflows and patient engagement strategies.",
      fullBio: "McKenna Lupold, DPT, combines her expertise as a licensed Doctor of Physical Therapy, pelvic health specialist, and clinic director to provide actionable insights into the design and usability of Virdio Health's platform. Her patient-first approach ensures the platform meets both clinical and real-world needs. Currently serving as Clinic Director at Phoenix Physical Therapy, McKenna also contributes to The Bladder Coach program, a virtual pelvic health coaching service. She brings a diverse background in outpatient orthopedics and rehabilitation, advising on best practices for clinical accuracy and program design.",
      linkedIn: "https://www.linkedin.com/company/virdiohealth",
      image: "/aboutimg/Lupold.svg",
    },
    {
      name: "Art Hoath",
      title: "Board Advisor",
      shortBio: "Art Hoath is a healthcare veteran who advises Virdio Health on payer strategies and growth. With expertise in value-based care, he helps optimize partnerships that benefit both payers and patients.",
      fullBio: "Art Hoath is a healthcare industry veteran with over 25 years of leadership in payer solutions, value-based care, and cost optimization. As Board Advisor to Virdio Health, he provides strategic guidance on go-to-market efforts, channel partnerships, and payer engagement to help scale the platform. Currently Chief Revenue Officer at Vitori Health, Art has held executive roles at healthcare innovators such as AMPS, Valenz, and Zelis. He has consistently led initiatives that reduce health plan costs while improving access and member experience.",
      linkedIn: "https://www.linkedin.com/company/virdiohealth",
      image: "/aboutimg/Hoath.svg",
    },
  ];

  /* ===== Approach pillars ===== */
  const approachPillars = ["Guided Self-Assessment that understands each person's pain, mobility, and goals in about 10 minutes", "Personalized recovery plans tailored to starting ability, with clear explanations of what's included and why", "Real-time voice coaching and on-screen AR targets that adapt to each person's range of motion", "Session-by-session adaptation based on progress and feedback. If something feels too hard, too easy, or uncomfortable, Myra adjusts", "Always available to answer questions between sessions"];
  if (showMemberBlockScreen) {
    return <BrowserBlockScreen featureType="member" />;
  }
  return (
    <div className="about-page">
      <Header setShowMemberBlockScreen={setShowMemberBlockScreen} onTryMyraClick={() => StartMyra(setIsMicModalActive, setIsMyRAIsActive)} />
      {isMicModalActive && <LandingPageModal message={micModalMsg} onGrant={onGrant} onCancel={oncancel} isMicModalActive={isMicModalActive} setIsMicModalActive={setIsMicModalActive} access={access} setAccess={setAccess} setMicModalMsg={setMicModalMsg} />}
      {/* HERO */}
      <section className="about-hero">
        <div className="about-hero-inner">
          <p className="section-label">About Virdio Health</p>
          <h1>Why We Reimagined Recovery</h1>
          <p className="about-hero-desc">Everyone on our team had lived it. The frustration of muscle and joint pain that lingered, the good intentions to recover, and the drop-off that always came too soon. We came together not just as professionals, but as people who knew what it felt like to want your life back and not have the right tools to get there. Virdio Health was born from that shared experience, with a simple belief: recovery should feel possible and personal, every step of the way.</p>
        </div>
      </section>

      {/* MISSION */}
      <section className="block-section block-section--dark">
        <div className="block-grid">
          <div className="block-label">Our Mission</div>
          <div className="block-text">
            <p>To transform muscle and joint recovery by making it engaging, accessible, and outcomes-driven. Powered by AI and a human-centered approach that motivates, empowers, and delivers results.</p>
          </div>
        </div>
      </section>

      {/* VISION */}
      <section className="block-section block-section--light">
        <div className="block-grid">
          <div className="block-label">Our Vision</div>
          <div className="block-text">
            <p>A world where recovery from muscle and joint pain is no longer delayed, avoided, or abandoned. We believe every person deserves a faster, smarter, more encouraging, and more affordable path to feeling better.</p>
          </div>
        </div>
      </section>

      {/* STORY */}
      <section className="block-section block-section--dark">
        <div className="block-grid">
          <div className="block-label">Our Story</div>
          <div className="block-text">
            <p>Let's be honest: most people struggling with muscle and joint pain don't get the help they need. Recovery programs are time-consuming, often inconvenient, and for many, simply don't feel rewarding. That's not a failure of willpower; it's a failure of the system.</p>
            <p>Virdio Health set out to change that.</p>
            <p>Our story began with a familiar frustration. Co-founder Arjun Rishi had personally experienced lower back and knee pain and saw just how difficult it was to stay consistent with recovery. At the time, his team, including Chief R&amp;D Officer Nicholas Sterling, a 30-year veteran in AI and real-time systems, had been developing computer vision and augmented reality tools that guided human movement and delivered real-time feedback.</p>
            <p>It was in conversation with Dr. Mehul Desai, a nationally recognized pain specialist and longtime advocate for virtual rehabilitation, that the idea clicked: what if we applied this same technology, paired with AI and behavioral science, to make recovery more effective, accessible, and engaging?</p>
            <p>Alongside co-founder Ty Bordner and a team of experts in musculoskeletal care, behavioral motivation, and motion tracking, Virdio Health was created to solve the problem from the ground up. The result is Myra, an AI-powered recovery coach that guides people through assessment, builds personalized recovery plans, and adapts in real time based on how they move and how they feel.</p>
            <p>Not a scheduling tool. Not a clinician marketplace. A smarter, more human-centered way to help people recover. One that fits into real life, runs in any browser, and helps them feel seen, supported, and successful.</p>
          </div>
        </div>
      </section>

      {/* APPROACH TO CARE */}
      <section className="approach-section">
        <div className="approach-inner">
          <div className="approach-header">
            <p className="section-label">Our Approach</p>
            <h2 className="section-title">Recovery Guided by Myra, Designed Around You</h2>
          </div>
          <div className="approach-content">
            <p>Too often, recovery programs are rigid, inconvenient, or discouraging. People drop off not because they don't care, but because the experience doesn't meet them where they are. We built Myra to change that.</p>
            <p>Myra is Virdio Health's AI-powered recovery coach. She guides each person through a structured, evidence-based recovery experience, from initial assessment through every session, adapting in real time based on how they move and how they feel.</p>

            <div className="approach-values">
              <div className="approach-value">
                <strong>Encouragement</strong>
                <span>Not criticism</span>
              </div>
              <div className="approach-value">
                <strong>Structure</strong>
                <span>Not overwhelm</span>
              </div>
              <div className="approach-value">
                <strong>Progress</strong>
                <span>That feels rewarding</span>
              </div>
            </div>

            <p>Myra combines smart technology with compassionate support:</p>
            <ul className="approach-pillars">
              {approachPillars.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
            <p className="approach-closing">We don't just help people move better. We help them feel seen, supported, and successful.</p>
          </div>
        </div>
      </section>

      {/* LEADERSHIP */}
      <section className="leadership-section" id="leadership-team">
        <div className="leadership-inner">
          <div className="leadership-header">
            <p className="section-label">Leadership</p>
            <h2 className="section-title">The Team Behind Virdio Health</h2>
            <p>Our leadership team brings together decades of experience in technology, healthcare, and business, united by a shared vision: to make muscle and joint recovery smarter, more motivating, and more accessible.</p>
          </div>
          <div className="leadership-grid">
            {leaders.map((leader, i) => (
              <LeaderCard key={i} {...leader} />
            ))}
          </div>
        </div>
      </section>

      {/* ADVISORY BOARD */}
      <section className="approach-section" id="advisory-board">
        <div className="approach-inner">
          <div className="approach-header">
            <p className="section-label">Advisory Board</p>
            <h2 className="section-title">Guided by Experts</h2>
            <p style={{ fontSize: "1rem", color: "var(--gray-600)", lineHeight: 1.65, marginTop: "0.75rem", maxWidth: 650 }}>Our Advisory Board includes clinicians and strategists who help shape our clinical model, commercial approach, and long-term roadmap, ensuring Virdio Health stays at the forefront of AI-driven recovery.</p>
          </div>
          <div className="leadership-grid">
            {advisors.map((advisor, i) => (
              <LeaderCard key={i} {...advisor} />
            ))}
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="about-cta">
        <div className="about-cta-inner">
          <h2>Experience Myra. Right Now.</h2>
          <p className="about-cta-sub">Take a free Guided Self-Assessment on your own device. The same experience your employees would have.</p>
          <button onClick={() => setShowAgeModal(true)} className="btn-primary" rel="noopener noreferrer">
            Start Your Free Guided Self-Assessment
          </button>
          <p className="about-cta-specialist">
            Prefer a conversation? <Link to="/contact-us">Speak with a specialist.</Link>
          </p>
        </div>
      </section>
      {showAgeModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h3>Confirmation Required</h3>
            <p>I confirm that I'm 18 years of age or older.</p>

            <div className="modal-buttons">
              <button
                className="btn-confirm"
                onClick={() => {
                  setShowAgeModal(false);
                  handleHomeButtonCLicked();
                }}
              >
                Confirm
              </button>

              <button className="btn-cancel" onClick={() => setShowAgeModal(false)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
};
